import { PLANET_GLYPH } from "./ZodiacWheel";
import { Sparkle } from "lucide-react";

export function PatternList({ patterns, title = "Rare Patterns" }) {
  if (!patterns || patterns.length === 0) return null;
  return (
    <div data-testid="pattern-list">
      <p className="overline gold-text mb-3">{title}</p>
      <div className="space-y-2">
        {patterns.map((p, i) => (
          <div key={i} className="rounded-lg bg-[#8A2BE2]/10 border border-[#8A2BE2]/25 p-3">
            <div className="flex items-center gap-2 mb-1">
              <Sparkle className="h-3.5 w-3.5 text-[#B47CF0]" strokeWidth={1.5} />
              <span className="text-sm font-medium text-white">{p.type}</span>
              <span className="text-xs text-white/40">{(p.planets || []).join(" · ")}{p.where ? ` in ${p.where}` : ""}</span>
            </div>
            <p className="text-xs text-white/60 leading-relaxed">{p.meaning}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function WesternAspectList({ aspects }) {
  if (!aspects || aspects.length === 0) return <p className="text-sm text-white/40">No major aspects.</p>;
  return (
    <div className="space-y-1" data-testid="aspect-list">
      {aspects.map((a, i) => (
        <div key={i} className="flex items-center justify-between text-sm py-1.5 border-b border-white/5">
          <span className="flex items-center gap-2">
            <span className="gold-text w-4 text-center">{PLANET_GLYPH[a.a]}</span>
            <span style={{ color: a.color }} className="text-xs font-medium w-20">{a.aspect}</span>
            <span className="gold-text w-4 text-center">{PLANET_GLYPH[a.b]}</span>
            <span className="text-white/60 text-xs">{a.a} – {a.b}</span>
          </span>
          <span className="text-white/30 text-xs">{a.orb}{"\u00b0"}</span>
        </div>
      ))}
    </div>
  );
}

export function VedicAspectList({ aspects }) {
  if (!aspects || aspects.length === 0) return <p className="text-sm text-white/40">No drishti.</p>;
  return (
    <div className="space-y-1" data-testid="vedic-aspect-list">
      {aspects.map((a, i) => (
        <div key={i} className="flex items-center justify-between text-sm py-1.5 border-b border-white/5">
          <span className="flex items-center gap-2">
            <span className="cyan-text w-4 text-center">{PLANET_GLYPH[a.from]}</span>
            <span className="text-white/60 text-xs">aspects</span>
            <span className="cyan-text w-4 text-center">{PLANET_GLYPH[a.to]}</span>
          </span>
          <span className="text-white/30 text-xs">{a.aspect}</span>
        </div>
      ))}
    </div>
  );
}

export function ChineseRelationList({ relations }) {
  const all = [...(relations?.branch_relations || []), ...(relations?.stem_relations || [])];
  if (all.length === 0) return <p className="text-sm text-white/40">No notable pillar relations.</p>;
  return (
    <div className="space-y-2" data-testid="chinese-relation-list">
      {all.map((r, i) => (
        <div key={i} className={`rounded-lg p-3 border ${r.quality === "harmonious" ? "bg-[#45F0DF]/8 border-[#45F0DF]/20" : "bg-[#F26D6D]/8 border-[#F26D6D]/20"}`}>
          <div className="flex items-center gap-2 mb-0.5">
            <span className="text-sm font-medium">{r.type}</span>
            <span className="text-xs text-white/40">{r.between.join(" · ")}</span>
          </div>
          <p className="text-xs text-white/60">{r.meaning}</p>
        </div>
      ))}
    </div>
  );
}
